<template>
  <div class="c-footer-nav">
    <div class="c-nav" :class="active == 0 ? 'active':''" @click="jump(0)">
      <span class="icon">
        <img src="~@/assets/images/my/home-icon-active.png" alt />
        <img src="~@/assets/images/my/home-icon.png" alt />
      </span>
      <span class="text">招牌</span>
    </div>
    <div class="c-nav" :class="active == 1 ? 'active':''" @click="jump(1)">
      <span class="icon">
        <img src="~@/assets/images/my/train-icon-active.png" alt />
        <img src="~@/assets/images/my/train-icon.png" alt />
      </span>
      <span class="text">训练营</span>
    </div>
    <!-- <div class="c-nav" :class="active == 2 ? 'active':''" @click="jump(2)">
      <img class="c-center" src="~@/assets/images/my/footer-icon-center.png" alt />
    </div>-->
    <div class="c-nav" :class="active == 3 ? 'active':''" @click="jump(3)">
      <span class="icon">
        <img src="~@/assets/images/my/offline-icon-active.png" alt />
        <img src="~@/assets/images/my/offline-icon.png" alt />
      </span>
      <span class="text">实战坊</span>
    </div>
    <div class="c-nav" :class="active == 4 ? 'active':''" @click="jump(4)">
      <span class="icon">
        <img src="~@/assets/images/my/my-icon-active.png" alt />
        <img src="~@/assets/images/my/my-icon.png" alt />
      </span>
      <span class="text">我的</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      routes: [
        { name: 'home', query: { adminId: this.$route.query.adminId } },
        { name: 'train-list', query: { adminId: this.$route.query.adminId } },
        { name: 'rights-interests', query: { goodsId: 171 } },
        {
          name: 'offline-class-list',
          query: { adminId: this.$route.query.adminId },
        },
        { name: 'my', query: { adminId: this.$route.query.adminId } },
      ],
    }
  },
  methods: {
    jump(i) {
      this.$router.push({
        name: this.routes[i].name,
        query: this.routes[i].query,
      })
    },
  },
}
</script>

<style scoped lang="less">
.c-footer-nav {
  display: flex;
  width: 750px;
  height: 118px;
  // height: 108px;
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 9;
  padding-bottom: 10px;
  justify-content: space-around;
  box-shadow: rgba(210, 210, 210, 0.5) 0 -1px 3px;
  background-color: #fff;
  transform: translateX(-50%) translateZ(0);

  .c-nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .c-center {
      width: 112px;
      height: 86px;
    }
    &.active {
      .icon {
        img:nth-child(2) {
          display: none;
        }
        img:nth-child(1) {
          display: block;
        }
      }
      .text {
        color: #f50;
      }
    }

    .icon {
      img:nth-child(1) {
        display: none;
      }
      img:nth-child(2) {
        display: block;
      }
      img {
        width: 48px;
        height: 44px;
      }
    }
    .text {
      font-size: 20px;
      color: #727070;
      line-height: 30px;
    }
  }
}
</style>